import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { trio } from 'ldrs';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./filterData.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { BsArrowLeft } from "react-icons/bs";
import Cookies from 'js-cookie';
import { ring } from 'ldrs';
import {encryptData, decryptData } from "../../Auth/cryptage";






const FilterData = ({handleChatButtonClick}) => {
    trio.register();
    ring.register();
    axios.defaults.withCredentials = true;
    const MySwal = withReactContent(Swal);
    const [formValues, setFormValues] = useState({
        datedebut: '',
        datefin: '',
        filterBy: '',
    });
    const [dateField,setDateField] = useState([]);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState({
        who:'',
        status:false
    });
    const [savedPeriodExists, setSavedPeriodExists] = useState(false);
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const [fBloading, setFBLoading] = useState(true);
    const { nameR, typeR } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);
    useEffect(() => {
        getDateField();
        checkSavedPeriod();
    },[]);
    useEffect(() => {
        document.title = "GecimmoIA - FilterData";
    }, []); 
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });

        if (name === 'comboBoxValue') {
            const dates = getDatesForOption(value);
            setFormValues({ ...formValues, ...dates });
        }
        if (name === 'filterBy') {
            setFormValues({ ...formValues, [name]:value });
            setFBLoading(false);
            // // console.log()(name,value);
        }
        if (name === 'checkbox') {
            setCheckboxChecked(e.target.checked);
        } 
    };
    
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const getDateField = async () => {
        try {
            setLoading({ who: 'field', status: true });
            const token = decryptData(Cookies.get('access_token'));
            const response = await axios.get(`https://api.ai.easysystem.cloud/api/getDateColumns/${nameR}`, {
                headers: {
                    'X-Custom-Token': token
                }
            });
    
            setDateField(response.data.columns);
        } catch (err) {
            console.error("Error fetching date fields: ", err);
    
            let errorMessage = "An unexpected error occurred";
    
            if (err.response) {
                errorMessage = err.response.data?.error || errorMessage;
            } else if (err.request) {
                errorMessage = "No response received from the server. Please try again later.";
            } else {
                errorMessage = err.message || errorMessage;
            }
            await MySwal.fire({
                title: "Error!",
                text: errorMessage,
                icon: "error"
            });
    
            setDateField([]); 
        } finally {
            setLoading({ who: 'field', status: false });
        }
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading({ who: 'submit', status: true });
        try {
            const token = decryptData(Cookies.get('access_token'));
            const transformedFormValues = {
                datedebut: formValues.datedebut ? formatDate(new Date(formValues.datedebut)) : '',
                datefin: formValues.datefin ? formatDate(new Date(formValues.datefin)) : '',
                filterBy: formValues.filterBy,
                checkboxChecked:checkboxChecked
            };

            const response = await axios.post(`https://api.ai.easysystem.cloud/api/user/fillterData/${nameR}/${typeR}`, transformedFormValues, {
                headers: {
                    'X-Custom-Token': token
                }
            });
            sessionStorage.clear();
            if (response.data.error) {
                await MySwal.fire({
                    title: "Error!",
                    text: response.data.error,
                    icon: "error"
                });
                return;
            }
            handleChatButtonClick();
            sessionStorage.setItem('messages', encryptData(JSON.stringify(response.data)));
            setLoading({ who: 'submit', status: false });
            navigate('/chat');
        } catch (err) {
            setLoading({ who: 'submit', status: false });
    
            if (err.response) {
                const status = err.response.status;
                const errorText = err.response.data?.error || "An unexpected error occurred";
    
                if (status === 403) {
                    navigate("/home");
                    await MySwal.fire({
                        title: "Error!",
                        text: "Introuvable ou vous n'y avez pas accès",
                        icon: "error"
                    });
                } else {
                    await MySwal.fire({
                        title: "Error!",
                        text: errorText,
                        icon: "error"
                    });
                }
            } else if (err.request) {
                await MySwal.fire({
                    title: "Network Error",
                    text: "No response received from the server. Please try again later.",
                    icon: "error"
                });
            } else {
                await MySwal.fire({
                    title: "Error!",
                    text: err.message || "An unexpected error occurred",
                    icon: "error"
                });
            }
        }
    };
    

    const back = () => {
        navigate('/home');
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const formatDate = (date) => {
        const pad = (num) => (num < 10 ? '0' + num : num);
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.000`;
    };

    const getDatesForOption = (option) => {
        const currentDate = new Date();
        let startDate;
        let endDate = formatDate(currentDate);

        switch (option) {
            case 'option1':
                startDate = new Date(currentDate.setDate(currentDate.getDate() - 7));
                break;
            case 'option2':
                startDate = new Date(currentDate.setMonth(currentDate.getMonth() - 1));
                break;
            case 'option3':
                startDate = new Date(currentDate.setMonth(currentDate.getMonth() - 3));
                break;
            default:
                startDate = '';
                endDate = '';
        }

        return {
            datedebut: startDate ? formatDate(startDate) : '',
            datefin: endDate,
        };
    };


    const checkSavedPeriod = async () => {
        try {
            const token = decryptData(Cookies.get('access_token'));
            const response = await axios.get("https://api.ai.easysystem.cloud/api/user/fillterData/periode", {
                headers: {
                    'X-Custom-Token': token
                }
            });
            const datedebut = response.data.date_debut;
            const datefin = response.data.date_fin;
            if (datedebut && datefin) {
                setSavedPeriodExists(true)
                setFormValues({ ...formValues, datedebut:datedebut, datefin:datefin });
            // // console.log()(datedebut);
            }
        } catch (err) {
            setSavedPeriodExists(false);
            // console.log()(err);
        }
    };



    return (
        <>
            {loading.status && loading.who==='submit' && (<div className="loading-overlay"><l-trio size="50" speed="1.3" color="black"></l-trio>Analyse en cours...</div>)}
            <div className={`FDcontainer ${loading.status && loading.who==='submit' ? 'blur' : ''}`}>
                <form onSubmit={handleSubmit} className={`filterForm d-flex flex-column align-items-center my-5 ${loading.status && loading.who === 'field'? 'blur' : ''}`}>
                    <h5 className="filterCard-title mb-4">Filtrer les données</h5>
                    <div className="mb-3 w-100">
                        <label htmlFor="comboBoxValue2" className="filterForm-label">Filtrer par :</label>
                        <select
                            id="comboBoxValue2"
                            name="filterBy"
                            className="form-select"
                            onChange={handleChange}
                            defaultValue=""
                        >
                            <option value="" disabled hidden>
                                {loading.status && loading.who === 'field' ? (
                                    "Loading..."
                                ) : (
                                    "Filtrer par"
                                )}
                            </option>
                            {dateField.map((field, index) => (
                                <option key={index} value={field}>{field}</option>
                            ))}
                        </select>
                    </div>

                    <div className="mb-3 w-100">
                        <label htmlFor="comboBoxValue" className="filterForm-label">Période</label>
                        <select
                            id="comboBoxValue"
                            option="choisir la Période"
                            name="comboBoxValue"
                            className="form-select"
                            onChange={handleChange}
                            disabled={fBloading}
                        >
                            <option value="option1">Semaine dernière</option>
                            <option value="option2">Ce mois</option>
                            <option value="option3">Ces 3 derniers mois</option>
                        </select>
                    </div>
                    <div className="mb-3 w-100">
                    {
                        savedPeriodExists && (
                            <button type="button" className="FilterBtns btn btn-info w-100 mb-2" onClick={handleSubmit} disabled={fBloading}>
                                <span className='PeriodeS'>Période memorisée : {formValues.datedebut} / {formValues.datefin}</span>
                            </button>
                    )}
                        <button type="button" className="FilterBtns btn btn-secondary w-100 mb-2" onClick={handleClickOpen} disabled={fBloading}>
                            Personnaliser la période
                        </button>
                        <button type="submit" className="btn btn-primary w-100" disabled={fBloading}>
                            Analyse
                        </button>
                        <button className="filterbackbtn btn mt-2 w-100" onClick={back} size="lg" >
                            <BsArrowLeft className="filterbtnbackIcon" />
                            Back
                        </button>
                    </div>
                </form>
                <div data-aos="flip-down" className={`modal ${open ? 'show' : ''}`} style={{ display: open ? 'block' : 'none' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Personnaliser la date</h5>
                                <button type="button" className="btn-close" onClick={handleClose}></button>
                            </div>
                            <div className="modal-body">
                                <p>Veuillez entrer la date de début et la date de fin.</p>
                                <div className="mb-3">
                                    <label htmlFor="datedebut" className="form-label">Date de début</label>
                                    <input
                                        id="datedebut"
                                        type="datetime-local"
                                        name="datedebut"
                                        className="form-control filterForm-control"
                                        value={formValues.datedebut}
                                        onChange={handleDateChange}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="datefin" className="form-label">Date de fin</label>
                                    <input
                                        id="datefin"
                                        type="datetime-local"
                                        name="datefin"
                                        className="form-control filterForm-control"
                                        value={formValues.datefin}
                                        onChange={handleDateChange}
                                    />
                                </div>
                                <label className="check">
                                    <input
                                        type="checkbox"
                                        name="checkbox"
                                        checked={checkboxChecked}
                                        onChange={handleChange}
                                    />
                                    <svg viewBox="0 0 64 64" height="1em" width="1em">
                                        <path
                                            d="M 0 16 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 16 L 32 48 L 64 16 V 8 A 8 8 90 0 0 56 0 H 8 A 8 8 90 0 0 0 8 V 56 A 8 8 90 0 0 8 64 H 56 A 8 8 90 0 0 64 56 V 16"
                                            pathLength="575.0541381835938"
                                            className="path"
                                        ></path>
                                    </svg>
                                </label>
                            <label htmlFor="souv" style={{ color: "black" }}> Me souvenir de la période</label>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleClose}>Annuler</button>
                                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                                    Analyse
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FilterData;
